import { useState, useRef, useEffect } from 'react';
import { deleteManagementAttributes, updateManagementAttributes, getManagementAttributes } from '../../../../../../util/APIUtils';
import { useContactManagementHook } from '../../../contact-management/useContactManagementHook';
import { VOICE_CALL } from '../../../../constants/voice-call-constants';
import { PRODUCT_TYPES } from '../../../../constants/video-call-constants';
import { fetchScheduleSettings } from '../../../../utils/schedule-utils';
const useGroupScheduleSettingsHook = ({ locationId }) => {
  const { groupScheduleDefault } = useContactManagementHook({locationId});
  const [isCreateScheduleModalOpen, setIsCreateScheduleModalOpen] = useState(false);
  const [isNewScheduleAdded, setIsNewScheduleAdded] = useState(false);
  const [groupScheduleSettings, setGroupScheduleSettings] = useState([]);
  const [allSchedulesOptions, setAllSchedules] = useState([]);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [maxMinutesLimit, setMaxMinutesLimit] = useState(VOICE_CALL.MAX_NO_OF_MINUTES_PER_DAY_PER_LEARNER);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showSnackBar, setShowSnackBar] = useState(false); 
 const modalRef = useRef(null);
  const handleCreateScheduleModalOpen = () => {
    modalRef.current.toggleModal();
  };

  useEffect(() => {
    if(groupScheduleDefault && groupScheduleDefault.attributeValue){
      const defaultGroupSchedule = allSchedulesOptions.find(schedule => schedule.value == groupScheduleDefault.attributeValue);
      setSelectedSchedule(defaultGroupSchedule ?  defaultGroupSchedule : allSchedulesOptions[0]);
    }
    else{
      setSelectedSchedule(allSchedulesOptions[0]);
    }
  },[groupScheduleDefault,allSchedulesOptions]);

  useEffect(() => {
    const fetchMaxMinutesLimit = async () => {
      try {
        const managementAttributes = await getManagementAttributes(locationId);
        if (managementAttributes?.locationAttributes) {
          const maxMinutesAttribute = managementAttributes.locationAttributes.find(
            attr => attr.attributeName === VOICE_CALL.MAX_MINUTES_ALLOWED_PER_DAY_PER_LEARNER_ATTRIBUTE_KEY
          );
          if (maxMinutesAttribute) {
            setMaxMinutesLimit(parseInt(maxMinutesAttribute.attributeValue));
          }
        }
      } catch (error) {
        console.error('Error fetching max minutes limit:', error);
      }
    };

    fetchMaxMinutesLimit();
  }, [locationId]);

  const handleDefaultScheduleChange = (event, defaultSchedule) => {
    handleUpdate(defaultSchedule);
  };

  const handleUpdate = async (defaultSchedule) => {
    try {
      setSelectedSchedule(defaultSchedule);
      const obj = {
        attributeId: groupScheduleDefault && groupScheduleDefault.attributeId ? groupScheduleDefault.attributeId : null,
        attributeName: VOICE_CALL.GROUP_SCHEDULE_DEFAULT_ATTRIBUTE_KEY,
        attributeValue: defaultSchedule.value,
      };
      if(defaultSchedule.value === -1){
        await deleteManagementAttributes({
          locationId: locationId,
          locationAttributes: [obj],
        });
      }
      else{
        await updateManagementAttributes({
          locationId: locationId,
          locationAttributes: [obj],
        });
      }

    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const loadGroupScheduleSettings = async () => {
      setLoading(true);
      setError(null);
      setAllSchedules([]);
      try {
        const data = await fetchScheduleSettings({ locationId, productType: PRODUCT_TYPES.VOICE });
        if (data) {
          const sortedData = data.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
          setGroupScheduleSettings(sortedData);
          populateDefaultScheduleOptions(sortedData);
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    loadGroupScheduleSettings();
  }, [locationId, isNewScheduleAdded]);

  const onDeleteSchedule = () => {
    setLoading(true);
    fetchScheduleSettings({ locationId, productType: PRODUCT_TYPES.VOICE })
      .then((data) => {
        if (data) {
          const sortedData = data.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
          setGroupScheduleSettings(sortedData);
          populateDefaultScheduleOptions(sortedData);
        }
      })
      .catch((error) => {
        setError(error.message);
      })
      .finally(() => {
        setLoading(false);
        setShowSnackBar(true);
      });
  };

  const populateDefaultScheduleOptions = (sortedData)=>{
    const optionsData = sortedData.map((schedule) => ({
      value: schedule.id,
      label: schedule.scheduleName,
    }));
    optionsData.unshift({ value: -1, label: 'No Schedule' });
    setAllSchedules(optionsData);
  };

  const handleCreateScheduleModalClose = () => {
    setIsCreateScheduleModalOpen(false);
  };
  return {
    isCreateScheduleModalOpen,
    handleCreateScheduleModalOpen,
    handleCreateScheduleModalClose,
    modalRef,
    isNewScheduleAdded,
    groupScheduleSettings,
    loading,
    error,
    showSnackBar,
    setShowSnackBar,
    onDeleteSchedule,
    setIsNewScheduleAdded,
    handleDefaultScheduleChange,
    allSchedulesOptions,
    selectedSchedule,
    maxMinutesLimit,
  };
};

export default useGroupScheduleSettingsHook;
